import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataService_FacilitySetup } from "../data.service";
import { IDCardRequestModel } from "../IDCardRequestModel";

@Component({
	selector: "caass-siteadmin-facility-visitor-pass",
	templateUrl: "./siteadmin-facility-visitor-pass.component.html",
	styleUrls: ["./siteadmin-facility-visitor-pass.component.css"],
})
export class SiteadminFacilityVisitorPassComponent implements OnInit {
	constructor(private facilityService: DataService_FacilitySetup) {}

	ngOnInit(): void {
		this.loadVisitorPassTemplates();

		this.UpdateFromMain();
	}

	ngOnChanges() {
		this.UpdateFromMain();
	}

	UpdateFromMain() {
		if (this.EnableOffenderSearchFromMain != undefined) {
			this.EnableOffenderSearch = this.EnableOffenderSearchFromMain;
		}
		if (this.VerificationPassIDFromMain != undefined) {
			this.VerificationPassID = this.VerificationPassIDFromMain;
		}
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////
	@Input() Saving: any = false;

	@Output() NextClick: EventEmitter<any> = new EventEmitter();

	@Input() EnableOffenderSearchFromMain: any;
	@Input() VerificationPassIDFromMain: any;
	@Input() FacilityIDFromMain: any = [];
	@Input() EditMode: any = false;

	//Form data
	EnableOffenderSearch: any = false;

	VerificationPassID: any = 0;
	lstPassTemplate: any = [];

	errorMessage: any = "";

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	loadVisitorPassTemplates() {
		var result = this.facilityService.loadIDCardTemplates(this.FacilityIDFromMain);
		result.subscribe(
			(response) => {
				this.lstPassTemplate = response;

				this.lstPassTemplate.unshift({
					IDCardTemplateID: "-1",
					CardName: "None",
				});

				this.VerificationPassID = this.lstPassTemplate[0].IDCardTemplateID;

				if (this.VerificationPassIDFromMain != undefined && this.VerificationPassIDFromMain != "") {
					this.VerificationPassID = this.VerificationPassIDFromMain;
				}
			},
			(error) => {}
		);
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onNext() {
		let myData: any = {
			EnableOffenderSearch: this.EnableOffenderSearch,
			VerificationPassID: this.VerificationPassID,
		};

		this.NextClick.emit({
			NextPage: 5,
			Data: myData,
		});
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////
	GetFinishText() {
		if (this.EditMode == true) {
			return "Update Facility";
		} else {
			return "Finish";
		}
	}
	///////////////////////////////////////////////////////
}
